export enum ExchangeSubAccountType {
  BINANCE = 'Binance',
  FTX = 'FTX',
  BITFINEX = 'Bitfinex'
}

export enum ErrorCode {
  EXPIRED_TOKEN_ERROR = 401,
  MANY_REQUEST_LIMIT_ERROR = 429
}
